import * as z from "zod";

export const getIntercomConversationCount = {
  name: "getIntercomConversationCount" as const,

  input: z.object({
    dateRange: z.object({
      start: z.date().nullable(),
      end: z.date().nullable(),
    }),
    excludeProducts: z.array(z.string()),
  }),

  output: z.object({
    totalCount: z.number(),
    emailAttempted: z.number(),
    emailResolved: z.number(),
    emailEscalated: z.number(),
  }),
};
